export default [
  {
    path: "/ff3c63ef97e0d684ed9f37d95fa357af7976fc7b0f43bacf",
    name: "bece26.payments",
    meta: {
      title: "BECE 2026 Payment(s)",
      authRequired: true,
      acc: ["y37611"],
    },
    component: () => import("@/views/bece/tws/payment/index.vue"),
  },
  {
    path: "/ff45320cbc0d608958b821968325677a1e2ec5c967470710",
    name: "bece26.pin.requests",
    meta: {
      title: "BECE 2026 Pin Request(s)",
      authRequired: true,
      acc: ["y37611"],
    },
    component: () => import("@/views/bece/tws/payment/index2.vue"),
  },
  {
    path: "/ff77a862e70d0dab92f5273d32d06049ff193c4af4944655",
    name: "bece26.pin.transactions",
    meta: {
      title: "BECE 2026 Pin purchase Transaction",
      authRequired: true,
      acc: ["y961645"],
    },
    component: () => import("@/views/bece/tws/payment/transactions.vue"),
  },
  {
    path: "/ff5937c7e766b0deba243ef110c6d1a42c55b7fe6e6f6b59",
    name: "bece26.pin.requests.transactions",
    meta: {
      title: "BECE 2026 Pin Request",
      authRequired: true,
      acc: ["y961645"],
    },
    component: () => import("@/views/bece/tws/payment/transactions2.vue"),
  },
  {
    path: "/s8y3NA",
    name: "bece26.pinanalysis",
    meta: {
      title: "BECE 2026 Pin Analysis",
      authRequired: true,
      acc: ["y10163"],
    },
    component: () => import("@/views/bece/tws/payment/analysis.vue"),
  },
];
